/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareNumber1 = createReactComponent("outline", "square-number-1", "IconSquareNumber1", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

export { IconSquareNumber1 as default };
//# sourceMappingURL=IconSquareNumber1.mjs.map
